/**
Accordion 

Markup:
<div class="accordion"
     data-mage-init='{"js/munro.accordion": {
        "panelSelector": "[data-accordion__panel]",
        "toggleSelector": "[data-accordion__toggle]",
        "contentSelector": "[data-accordion__content]"
     }}'>
    <section class="accordion__panel" data-accordion__panel>
        <header class="accordion__header" data-accordion__toggle>
            <h4 class="accordion__heading"></h4>
        </header>
        <div class="accordion__content" data-accordion__content>
            ...
        </div>
    </section>
    <section class="accordion__panel" data-accordion__panel>
        <header class="accordion__header" data-accordion__toggle>
            <h4 class="accordion__heading"></h4>
        </header>
        <div class="accordion__content" data-accordion__content>
            ...
        </div>
    </section>
    <section class="accordion__panel" data-accordion__panel>
        <header class="accordion__header" data-accordion__toggle>
            <h4 class="accordion__heading"></h4>
        </header>
        <div class="accordion__content" data-accordion__content>
            ...
        </div>
    </section>
</div>


Styleguide Components.Accordion
 */
define([
    'jquery'
], function($) {
    'use strict';

    $.widget('munro.accordion', {
        options: {
            enabledClass: 'accordion--enabled',
            panelOpenClass: 'open',
            contentHiddenClass: 'u-visually-hidden',
            autoOpenFirstAccordion: false,
            panelSelector: '[data-accordion__panel]',
            contentSelector: '[data-accordion__content]',
            toggleSelector: '[data-accordion__toggle]'
        },

        _create () {
            
            if (this.options.autoOpenFirstAccordion) {
                $(sections.get(0))
                    .find(this.options.toggleSelector)
                    .click();
            }
            this.element.addClass(this.options.enabledClass);
            this._watch();
        },

        /**
         * Initialised the handlers for the accordion
         *
         * @returns null
         */
        _watch () {
            this.element.on('click', this.options.toggleSelector, this._onToggleClick.bind(this));
        },


        /**
         * Handle showing/hiding the accordion section content
         *
         * @return null
         */
        _onToggleClick (event) {
            const $toggle = $(event.target);
            const $panel = $toggle.closest(this.options.panelSelector);
            const $content = $panel.find(this.options.contentSelector)

            $panel.toggleClass(this.options.panelOpenClass);
            $content.toggleClass(this.options.contentHiddenClass);
        }
    });

    return $.munro.accordion;
});
